import { homeownerQuotesService } from '@/services/quotes/homeowner';
import type {
  GetProposalPdfPayload,
  GetProposalPdfResponse,
} from '@/services/quotes/types';
import { useMutation } from '@tanstack/react-query';

export function useGenerateProposalPdf() {
  return useMutation<GetProposalPdfResponse, Error, GetProposalPdfPayload>({
    mutationKey: ['proposals', 'pdf'],
    mutationFn: async payload => {
      const response = await homeownerQuotesService.getProposalPdf(payload);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao gerar PDF');
      }
      return response.data;
    },
  });
}
